export const SYSTEM_ERROR_TXT = 'System error'

export const UNABLE_ADD_DEVICE_TXT = 'Unable to add the device' 
